import { render, staticRenderFns } from "./RuleBuilder.vue?vue&type=template&id=6442713c&scoped=true"
import script from "./RuleBuilder.vue?vue&type=script&lang=ts"
export * from "./RuleBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6442713c",
  null
  
)

export default component.exports